/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { validateYupSchema } from '../../lib/formik/Formik';
import { bankObject } from '../../components/investors/bankDetails';
//import { getDocumentDetails } from '../../components/investors/documentDetails';
import { contactPersonObject } from '../../components/NonIndividualInvestor/ContactDetails';
import { document_object } from '../../components/NonIndividualInvestor/DocumentDetails';
import { percentageError } from '../../components/NonIndividualInvestor/ubo';
import {
  applicantStatusMasters,
  APPLICATION_TYPE,
  APPLICATION_TYPE_FOR_DOCUMENTS,
  FAMILY_MAPPING_TYPE,
  IS_PENNYDROP_APPLICABLE_FOR_AMC,
  MPOWER_ACCOUNT_TYPE_MASTER,
  NEXEDGE_MDMS_APIS,
  NOMINEE_OPT_OUT_FEATURE_ENABLED,
  occupationDetailsMasters,
  onboardingTypeMasters,
  relatedRelations,
  salutationsMasters,
  uboOccupationDetailsMasters,
  USER_ROLES,
} from '../../utils/constant';
import { emailRegex, individualPanRegex, nonIndividualPanRegex } from '../../utils/regex';
import {
  bankDetailsSchema,
  personalDetailsSchema,
  documentDetailsSchema,
  FATCAValidationSchema,
  KYCDetailsSchema,
  nomineeDetailsSchema,
  nonIndividualContactDetailsSchema,
  NonIndividualContributorValidationSchema,
  nonIndividualDocumentDetailsSchema,
  relatedPersonSchema,
} from '../../utils/schema';
import {
  encodeBase64,
  getAddressData,
  getNomineeRelation,
  getOccupationType,
  getRelation,
  isMinor,
  isModuleAllowed,
  isOnboardingTypeMinor,
  relatedPersonPanValidation,
} from '../../utils/utilityFunctions';
import {
  AuthorisedErrors,
  BankError,
  CALL_API,
  RelatedPersonError,
  RiskProfileErrors,
  UboErrors,
} from '../middleware';
import { useDispatch, useSelector } from 'react-redux';

import {
  Applicant,
  ApplicationProps,
  Bank,
  NomineeType,
  Document,
  uboTypes,
  FetchUBORequestBody,
  StampPapersType,
  dashboardOnboardingType,
  monthwiseOnboardingSummaryType,
  distributorWisecommitmentType,
  monthwiseCommitmentAmountType,
  ubo,
  FatcaMdms,
  individuals_Poa_nonIndividuals_Documents,
  Groups,
  GroupSignatories,
  RiskProfileMasterType,
  CreateApplicationProps,
  ResubmitFatcaRequestBody,
  ResubmitFatcaResponseBody,
  UpdateChequeStatusRequestBody,
  UpdateChequeStatusResponseBody,
  NomineeOptOutGenerateOtpRequestBody,
  NomineeOptOutVerifyOtpRequestBody,
  NomineeOptOutVerifyOtpResponseBody,
  NomineeOptOutResendOtpRequestBody,
  NomineeOptOutApplicationPreviewResponseBody,
  GetBankSubAccountTypesRequestBody,
  GetBankSubAccountTypesResponseBody,
} from '../types/api-types';
import {
  CreateApplicationRequestBody,
  CREATE_APPLICATION,
  CREATE_APPLICATION_SUCCESS,
  GET_APPLICATION,
  GET_APPLICATION_SUCCESS,
  GET_ALL_APPLICATION_SUCCESS,
  GET_STAMPPAPER_DETAILS_SUCCESS,
  GET_STAMPPAPER_DETAILS,
  GET_DISTRIBUTOR_COMMITMENTAMOUNT_SUCCESS,
  GET_DISTRIBUTOR_COMMITMENTAMOUNT,
  GET_MONTHWISE_COMMITMENTAMOUNT_SUCCESS,
  GET_MONTHWISE_COMMITMENTAMOUNT,
  GET_ONBOARDING_SUMMARY_SUCCESS,
  GET_ONBOARDING_SUMMARY,
  GET_MONTHWISE_ONBOARDING_SUMMARY_SUCCESS,
  GET_MONTHWISE_ONBOARDING_SUMMARY,
  GET_ALL_APPLICATION,
  UPDATE_APPLICATION_SUCCESS,
  UPDATE_APPLICATION,
  AddJointHolderRequestBody,
  ADD_APPLICANT_SUCCESS,
  ADD_APPLICANT,
  GetAllApplicantsRequestBody,
  GetAllApplicantionsResponseBody,
  PENNY_DROP_VERIFICATION_SUCCESS,
  PENNY_DROP_VERIFICATION,
  GET_Documents_SUCCESS,
  GET_Documents,
  GET_Ubo_SUCCESS,
  GET_Ubo,
  UBO_LISTING_SUCCESS,
  UBO_LISTING,
  GET_Fatca_SUCCESS,
  GET_Fatca,
  IS_DECLARE_SUCCESS,
  IS_DECLARE,
  RESUBMIT_FATCA_SUCCESS,
  RESUBMIT_FATCA,
  UPDATE_CHEQUE_STATUS_SUCCESS,
  UPDATE_CHEQUE_STATUS,
  NOMINEE_OPT_OUT_GENERATE_OTP_SUCCESS,
  NOMINEE_OPT_OUT_GENERATE_OTP,
  NOMINEE_OPT_OUT_VERIFY_OTP_SUCCESS,
  NOMINEE_OPT_OUT_VERIFY_OTP,
  NOMINEE_OPT_OUT_RESEND_OTP_SUCCESS,
  NOMINEE_OPT_OUT_RESEND_OTP,
  NOMINEE_OPT_OUT_APPLICATION_PREVIEW_SUCCESS,
  NOMINEE_OPT_OUT_APPLICATION_PREVIEW,
  GET_BANK_SUB_ACCOUNT_TYPES_SUCCESS,
  GET_BANK_SUB_ACCOUNT_TYPES,
} from '../types/application';
import { mdmsCountriesList, nationaliyType } from '../types/mdms';
import { getNationalityList } from './mdms';
import { handleIntialSelect, RiskProfileObj } from '../../components/investors/riskProfileDetails';

export const createApplication =
  (body: CreateApplicationRequestBody) =>
    async (dispatch: any): Promise<CreateApplicationProps> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/applications`,
          method: 'POST',
          types: [CREATE_APPLICATION_SUCCESS, CREATE_APPLICATION],
          body,
        },
      });
    };

export const getApplicationDetails =
  (applicationId: string, method = '') =>
    async (dispatch: any): Promise<ApplicationProps> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/applications/${applicationId}`,
          method: method ? 'DELETE' : 'GET',
          types: [GET_APPLICATION_SUCCESS, GET_APPLICATION],
        },
      });
    };
export const getParams = (paramsObj: Partial<GetAllApplicantsRequestBody>) => ({
  type: 'GET_PARAMS_DATA',
  paramsObj,
});

export const sendIsDeclareTermsAndConditions =
  (applicantionId: string) =>
    async (dispatch: any): Promise<ApplicationProps> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/applications/isDeclareTermsAndConditions/${applicantionId}`,
          method: 'POST',
          types: [IS_DECLARE_SUCCESS, IS_DECLARE],
        },
      });
    };

export const getAllApplications =
  ({ storeInRedux = true, rawStatus, ...params }: Partial<GetAllApplicantsRequestBody>) =>
    async (dispatch: any): Promise<GetAllApplicantionsResponseBody> => {
      if (storeInRedux) {
        await dispatch(getParams({ ...params, rawStatus }));
      }
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/applications`,
          method: 'GET',
          types: [GET_ALL_APPLICATION_SUCCESS, GET_ALL_APPLICATION],
          params: {
            limit: 10,
            sort: 'createdAt',
            order: 'DESC',
            ...params,
          },
        },
      });
    };

export const onboardingSummary =
  () =>
    async (dispatch: any): Promise<dashboardOnboardingType> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/dashboard/onboardingSummary`,
          method: 'GET',
          types: [GET_ONBOARDING_SUMMARY_SUCCESS, GET_ONBOARDING_SUMMARY],
        },
      });
    };

export const monthwiseOnboardingSummary =
  () =>
    async (dispatch: any): Promise<monthwiseOnboardingSummaryType> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/dashboard/monthwiseOnboardingSummary?months=4`,
          method: 'GET',
          types: [GET_MONTHWISE_ONBOARDING_SUMMARY_SUCCESS, GET_MONTHWISE_ONBOARDING_SUMMARY],
        },
      });
    };

export const distributorWisecommitmentAmount =
  () =>
    async (dispatch: any): Promise<distributorWisecommitmentType> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/dashboard/distributorWisecommitmentAmount`,
          method: 'GET',
          types: [GET_DISTRIBUTOR_COMMITMENTAMOUNT_SUCCESS, GET_DISTRIBUTOR_COMMITMENTAMOUNT],
        },
      });
    };

export const monthwiseCommitmentAmount =
  () =>
    async (dispatch: any): Promise<monthwiseCommitmentAmountType> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/dashboard/monthwiseCommitmentAmount`,
          method: 'GET',
          types: [GET_MONTHWISE_COMMITMENTAMOUNT_SUCCESS, GET_MONTHWISE_COMMITMENTAMOUNT],
        },
      });
    };

// export const getStampPaperCount =
//   (params: Partial<GetAllApplicantsRequestBody>) =>
//   async (dispatch: any): Promise<GetAllApplicantionsResponseBody> => {
//     return await dispatch({
//       [CALL_API]: {
//         url: `/leegality/stampPaperDetails`,
//         method: 'GET',
//         types: [GET_STAMPPAPER_DETAILS_SUCCESS, GET_STAMPPAPER_DETAILS],

//       },
//     });
//   };

export const getStampPaperCount =
  () =>
    async (dispatch: any): Promise<StampPapersType> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/leegality/stampPaperDetails`,
          method: 'GET',
          types: [GET_STAMPPAPER_DETAILS_SUCCESS, GET_STAMPPAPER_DETAILS],
        },
      });
    };

export const updateApplication =
  ({
    body,
    applicationId,
    toastMessage,
  }: {
    body: Partial<ApplicationProps>;
    applicationId: string;
    toastMessage?: string;
  }) =>
    async (dispatch: any): Promise<ApplicationProps> => {
      const showToast = typeof toastMessage !== 'undefined';
      if (showToast) {
        toastMessage =
          `Application ${body.applicationNumber || ''} - ` + (toastMessage || ' Saved successfully');
      }
      try {
        return await dispatch({
          [CALL_API]: {
            url: `/onboarding/applications/${applicationId}/update`,
            method: 'POST',
            types: [UPDATE_APPLICATION_SUCCESS, UPDATE_APPLICATION],
            body,
            showToast,
            toastMessage,
          },
        });
      } catch (error: any) {
        console.log('catch error on update application', error);
        throw error;
      }
    };

export const addJointHolder =
  (body: AddJointHolderRequestBody, applicationId: string) =>
    async (dispatch: any): Promise<ApplicationProps> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/applications/${applicationId}/addApplicant`,
          method: 'POST',
          types: [ADD_APPLICANT_SUCCESS, ADD_APPLICANT],
          body,
        },
      });
    };

export const validatePersonalDetails = async (applicants: Partial<Applicant>[], role: any, currencyCode: string, company: string, application: ApplicationProps | null) => {
  const schemaData = {
    applicants: applicants.map((applicant) => ({
      ...applicant,
      namePrefix:
        applicant.namePrefix && salutationsMasters.includes(applicant.namePrefix || '')
          ? applicant.namePrefix
          : 'Mr.',
      jointApplicantRelation: getRelation(applicant.relationShipWithFirstApplicant)
        ? applicant.relationShipWithFirstApplicant
        : 'Others',
      relationShipWithFirstApplicant: getRelation(applicant.relationShipWithFirstApplicant)
        ? ''
        : applicant.relationShipWithFirstApplicant,
      occupationDetails: applicant.occupationDetails || '',
      maritalStatus: applicant.maritalStatus,
      occupationType: getOccupationType(applicant.occupationDetails)
        ? applicant.occupationDetails
        : 'Others',
      minorDOB: applicant.minorDOB || null,
      minorCountryNameAndCode: applicant.minorCountryNameAndCode || 'India: +91',
      minorNamePrefix: applicant.minorNamePrefix || 'Mr.',
      minorCountryCode: applicant.minorCountryCode || '+91',
    })),
    familyName: application?.familyName ?? "",
    familyId: application?.familyId ?? "",
    // For first time creation familyMappingType = existing as familyId and familyName are not there
    // For edit =>
    // 1. if new selected during creation => familyId will not be there, familyName will be there, so new
    // 2. if existing selected during creation => familyId will be there, so existing
    familyMappingType: (application?.familyId ?? "") ?
      FAMILY_MAPPING_TYPE.EXISTING :
      ((application?.familyName ?? "") ?
        FAMILY_MAPPING_TYPE.NEW :
        FAMILY_MAPPING_TYPE.EXISTING),
  };
  try {
    await validateYupSchema(schemaData, personalDetailsSchema(currencyCode, company, application), true, schemaData);
  } catch (error) {
    throw `Personal details`;
  }
};

export const validateRelatedPersonDetail = async (applicants: Partial<Applicant>[], role: any, currencyCode: string, company: string) => {
  const schemaData = {
    applicants: applicants,
  };

  try {
    relatedPersonPanValidation(applicants, company);
    await validateYupSchema(schemaData, relatedPersonSchema(currencyCode, company), true, schemaData);
  } catch (error) {
    if (error instanceof RelatedPersonError) {
      throw error;
    }
    throw `Related Person details`;
  }
};

export const validateKYCDetails = async (applicants: Partial<Applicant>[], role: any) => {
  const schemaData = {
    applicants: applicants.map((applicant) => ({
      grossAnnualIncome: applicant.grossAnnualIncome || '',
      politicallyExposedPersonStatus: applicant.politicallyExposedPersonStatus
        ? applicant.politicallyExposedPersonStatus
        : [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)
          ? ''
          : 'Not Applicable',
      ckycNo: applicant.ckycNo || '',
      grossAnnualIncomeDate: applicant.grossAnnualIncomeDate || '',
      netWorthDate: applicant.netWorthDate || '',
      netWorth: applicant.netWorth || '',
    })),
  };
  try {
    await validateYupSchema(schemaData, KYCDetailsSchema, true, schemaData);
  } catch (error) {
    throw `KYC details`;
  }
};

export const validateFATCA = async (
  applicants: Partial<Applicant>[],
  role: any,
  nationalitiesMdmsMasters: nationaliyType
) => {
  const schemaData = {
    applicants: applicants?.map((applicant) => ({
      typeOfAddressProvidedAtKRA: applicant.typeOfAddressProvidedAtKRA || '',
      taxResidentOfAnyCountryOtherThanIndia:
        applicant.taxResidentOfAnyCountryOtherThanIndia || false,
      placeOfBirth: applicant.placeOfBirth || '',
      countryOfBirth: applicant.countryOfBirth
        ? applicant.countryOfBirth.toUpperCase()
        : [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)
          ? ''
          : 'INDIA',
      countryOfNationality: applicant.countryOfNationality
        ? applicant.countryOfNationality.toUpperCase()
        : [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)
          ? ''
          : 'INDIA',
      taxCountryName: applicant?.taxCountryName ? `${applicant.taxCountryName}`.toUpperCase() : '',
      taxID: applicant.taxID || '',
      idType: applicant.idType || '',
      nameOfEntity: applicant.nameOfEntity || '',
      dateOfIncorporation: applicant.dateOfIncorporation || '',
      cityOfIncorporation: applicant.cityOfIncorporation || '',
      countryOfIncorporation: applicant.countryOfIncorporation || '',
      entityExcemptionCode: applicant.entityExcemptionCode || '',
    })),
    countryDropdown: nationalitiesMdmsMasters.countries.map((list) => list.name),
  };
  try {
    await validateYupSchema(schemaData, FATCAValidationSchema, true, schemaData);
  } catch (error) {
    throw `FATCA`;
  }
};

export const validateRiskProfile = async (
  application: ApplicationProps | null,
  riskProfileDataMaster: RiskProfileMasterType[]
) => {
  const {
    riskprofiles = [],
    riskProfileDeclaration = true,
    wishToAddRiskProfile = true,
  } = application || {};
  try {
    const schemaData = {
      wishToAddRiskProfile: wishToAddRiskProfile || false,
      riskProfileDeclaration: riskProfileDeclaration || true,
      riskprofiles: riskProfileDataMaster
        ?.map((mdmsProfile) => {
          const existingRiskProfiles = riskprofiles?.filter(
            (risk_profiles) => risk_profiles.question === mdmsProfile.key
          );
          return existingRiskProfiles.length
            ? existingRiskProfiles?.map((existingProfiles) => {
              if (
                existingProfiles.question === mdmsProfile.key &&
                mdmsProfile.isMultiselect === 'true'
              ) {
                const getInvestment = handleIntialSelect(riskprofiles, mdmsProfile.key);
                const checkAnswerArray = mdmsProfile.values?.map((_value) => _value.key);
                let getOtherValue = '';
                const updateOptions = getInvestment.map((ans) => {
                  if (!checkAnswerArray?.includes(ans.split('_')[0])) {
                    getOtherValue = ans.split('_')[0];
                    return `others_${ans.split('_')[1]}`;
                  }
                  return ans;
                });
                return {
                  ...existingProfiles,
                  ...mdmsProfile,
                  values: mdmsProfile.values?.map((value) => {
                    const scoreUpdate = updateOptions
                      .find((investment) => investment?.split('_')[0] === value.key)
                      ?.split('_')[1];

                    return {
                      ...value,
                      score: scoreUpdate ? Number(scoreUpdate) : value.score,
                    };
                  }),
                  InvestmentGoal: updateOptions || [],
                  scoreCal: Number(existingProfiles.scoreText) || 0,
                  otherValue: getOtherValue,
                  answer: getOtherValue
                    ? updateOptions?.toString()?.replace(/,/g, '*')
                    : existingProfiles.answer,
                };
              } else {
                const checkAnswer =
                  existingProfiles.question === mdmsProfile.key &&
                  mdmsProfile.isMultiselect === 'false' &&
                  mdmsProfile.values?.map((value) => value.key).includes(existingProfiles.answer);

                return {
                  ...existingProfiles,
                  ...mdmsProfile,
                  values: mdmsProfile.values?.map((value) => {
                    if (existingProfiles.answer === value.key) {
                      return {
                        ...value,
                        score: Number(existingProfiles.scoreText),
                      };
                    }
                    return value;
                  }),
                  otherValue: checkAnswer ? '' : existingProfiles.answer,
                  answer: checkAnswer ? existingProfiles.answer : 'others',
                };
              }
            })
            : [{ ...RiskProfileObj, question: mdmsProfile.key, ...mdmsProfile }];
        })
        .flat(),
    };

    const checkAllQuestionsAnswered = schemaData.riskprofiles
      ?.map((profile) => profile.answer !== '' && profile.required === 'true')
      ?.every((_profile) => _profile);
    if (!wishToAddRiskProfile && !checkAllQuestionsAnswered) {
      throw new RiskProfileErrors('In Risk Profile Please fill all the required(*) fields');
    }
    schemaData.riskprofiles?.map((risk) => {
      if (
        !wishToAddRiskProfile &&
        (risk.answer === 'others' ||
          (risk.isMultiselect === 'true' && risk.answer.includes('others'))) &&
        !risk.otherValue &&
        risk.required === 'true'
      ) {
        const questionForDisplay = riskProfileDataMaster
          ?.map((riskProfile) => {
            if (riskProfile.key === risk.question) {
              return riskProfile.displayText;
            }
            return;
          })
          ?.filter((ele) => ele)
          ?.toString();
        throw new RiskProfileErrors(
          'In Risk Profile Please specify others in ' + questionForDisplay
        );
      }
    });
    if (!wishToAddRiskProfile && !riskProfileDeclaration) {
      throw new RiskProfileErrors('In Risk Profile Declaration is required');
    }
    // await validateYupSchema(schemaData, riskProfileScheme, true, schemaData);
  } catch (e) {
    if (e instanceof RiskProfileErrors) {
      throw e;
    }
  }
};

export const validateNomineeDetails = async (
  Nominees: Partial<NomineeType>[],
  doNotWishToNominate: boolean,
  applicants: Partial<Applicant>[],
  onboardingType: string,
  currencyCode: string,
  company: string
) => {
  const schemaData = {
    doNotWishToNominate: isOnboardingTypeMinor(onboardingType || '')
      ? true
      : Nominees.length
        ? false
        : doNotWishToNominate === null
          ? true
          : doNotWishToNominate,
    nominees: Nominees.length
      ? Nominees.map((nominee) => ({
        ...nominee,
        Relationship: getNomineeRelation(nominee.nomineeRelationship?.toUpperCase())
          ? nominee.nomineeRelationship
            ? nominee.nomineeRelationship.toUpperCase()
            : nominee.nomineeRelationship
          : 'OTHERS',
        nomineeRelationship: getNomineeRelation(nominee.nomineeRelationship?.toUpperCase())
          ? ''
          : nominee.nomineeRelationship,
      }))
      : [],
  };
  try {
    await validateYupSchema(schemaData, nomineeDetailsSchema(applicants, currencyCode, company), true, schemaData);
  } catch (error) {
    throw `Nominee details`;
  }
};

export const validateBankDetails = async (
  bankDetails: Partial<Bank>[],
  verifyPennydrop: boolean,
  applicationType: string,
  applicants: Partial<Applicant>[],
  currencyCode: string,
) => {
  const schemaData = {
    applicationType: applicationType,
    status: applicants.length ? applicants[0].status : '',
    banks: bankDetails.length
      ? bankDetails.map((bank) => ({ ...bank, defaultBankAccount: !!bank.defaultBankAccount }))
      : [bankObject],
  };
  try {
    if (IS_PENNYDROP_APPLICABLE_FOR_AMC && verifyPennydrop) {
      const isAllBanksPennyChecked = bankDetails.every((bank) => bank.pennydropCheck);
      if (!isAllBanksPennyChecked) {
        throw new BankError('Please make sure that all the banks are verified');
      }
    }
    await validateYupSchema(schemaData, bankDetailsSchema(applicants, currencyCode), true, schemaData);
  } catch (error) {
    if (error instanceof BankError) {
      throw error;
    }
    throw `Bank details`;
  }
};

export const validateDocuments = async (
  applicants: Partial<Applicant>[],
  hasPOA: boolean,
  documentsData: Document,
  Nominees: Partial<NomineeType>[],
  application?: ApplicationProps | null,
) => {

  const isHeldAway = MPOWER_ACCOUNT_TYPE_MASTER[`${application?.accountType ?? ""}`?.toUpperCase()] === MPOWER_ACCOUNT_TYPE_MASTER['HLDAWY'];

  // In case of Nominee Otp out, nominee opt out document is required
  // When doNotWishToNominate = true and isBSEEnabled = true and isNomineeOptOutAuthenticated != '1'

  const isNomineeOptOutAuthRequired = application?.doNotWishToNominate && application?.isBSEEnabled && (application?.isNomineeOptOutAuthenticated !== '1')

  const schemaData = {
    applicants: applicants.map((applicant, applicant_index) => {

      const existingIdProofValue = applicant?.documents?.find(obj => obj.documentType === "identityProof")?.documentName ?? ""

      const existingAddressProofValue = applicant?.documents?.find(obj => obj.documentType === "addressProof")?.documentName ?? ""

      const permanentAddressEdited = applicant?.permanentAddressEdited;

      let docData = '';
      if (
        !hasPOA &&
        applicantStatusMasters[applicant.status as string] === applicantStatusMasters.Individual
      ) {
        if (
          onboardingTypeMasters[applicants[0].onboardingType as string] ===
          onboardingTypeMasters.minor
        ) {
          docData = APPLICATION_TYPE_FOR_DOCUMENTS.MINOR;
        } else {
          docData = APPLICATION_TYPE_FOR_DOCUMENTS.INDIVIDUAL;
        }
      }
      if (
        hasPOA &&
        applicantStatusMasters[applicant.status as string] === applicantStatusMasters.Individual
      ) {
        docData = APPLICATION_TYPE_FOR_DOCUMENTS.INDIVIDUAL_POA;
      }
      if (
        !hasPOA &&
        // applicantStatusMasters[applicant.status as string] === applicantStatusMasters.NRI
        (
          applicantStatusMasters[applicant.status as string] === applicantStatusMasters.NRE ||
          applicantStatusMasters[applicant.status as string] === applicantStatusMasters.NRO
        )
      ) {
        docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI;
      }
      if (
        hasPOA &&
        // applicantStatusMasters[applicant.status as string] === applicantStatusMasters.NRI
        (
          applicantStatusMasters[applicant.status as string] === applicantStatusMasters.NRE ||
          applicantStatusMasters[applicant.status as string] === applicantStatusMasters.NRO
        )
      ) {
        docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI_POA;
      }
      return {
        documents:
          typeof documentsData !== 'undefined'
            ? ((documentsData as Document)[docData] || [])
              .filter((doc) => {
                if (
                  hasPOA &&
                  applicant.applicant_type !== '1' &&
                  doc.documentType === 'poaNotarized'
                ) {
                  return;
                }
                return doc;
              })
              .filter((ele) => ele)
              .filter((document) => {
                if (applicant.amlCheck && document.documentType === 'compliance_document') {
                  return;
                }
                return document;
              })
              .filter((ele) => ele)
              .filter((doc) => {
                if (
                  !applicant.correspondenceAddressEdited &&
                  doc.documentType === 'correspondenceAddress'
                ) {
                  return;
                }
                return doc;
              })
              .filter((ele) => ele)
              .map((doc) => {
                if (
                  applicant.correspondenceAddressEdited &&
                  doc.documentType === 'correspondenceAddress'
                ) {
                  return { ...doc, required: 'true' };
                }
                return doc;
              })
              .map((doc) => {
                if (applicant.permanentAddressEdited && doc.documentType === 'addressProof') {
                  return { ...doc, required: 'true' };
                }
                return doc;
              })
              // to be commented out for bpi client start
              .map((doc) => {
                if (doc.documentType === 'investorSignature') {
                  return { ...doc, required: application?.onboardingVia?.toLowerCase() === 'physical' ? "false" : "true" }
                }
                if (doc.documentType === "identityProof") {
                  return { ...doc, required: (existingIdProofValue === "Aadhaar Card" || existingIdProofValue === "PAN Card") ? "true" : "false" }
                }
                if (doc.documentType === 'addressProof') {
                  return { ...doc, required: (existingAddressProofValue === "Aadhaar Card" || existingAddressProofValue === "PAN Card" || permanentAddressEdited) ? "true" : "false" }
                }
                if (doc.documentType === 'aadhaar_card') {
                  const aadhaarRequired = (existingIdProofValue === "Aadhaar Card" || existingAddressProofValue === "Aadhaar Card") ? "false" : "true";

                  const finalAadhaarRequired = (`${application?.onboardingVia ?? ""}`.toLowerCase() === 'digital') ? "false" : aadhaarRequired;

                  return { ...doc, required: finalAadhaarRequired }
                }
                if (doc.documentType === 'pan_card') {
                  return { ...doc, required: (existingIdProofValue === "PAN Card" || existingAddressProofValue === "PAN Card") ? "false" : "true" }
                }
                if (doc.documentType === "court_proof_of_guardian") {
                  return { ...doc, required: (applicant?.guardianRelationship === "COURT APPOINTED LEGAL GUARDIAN") ? "true" : "false" }
                }

                // Physical Signed Doc is required when isEsignEnabled is false and it is first applicant => start

                if (doc.documentType === 'physical_signed_document') {
                  return {
                    ...doc,
                    required: (
                      (application?.isEsignEnabled === false) &&
                      (applicant?.applicant_type === '1')
                    ) ? 'true' : 'false'
                  }
                }

                // Physical Signed Doc is required when isEsignEnabled is false and it is first applicant => end

                // KYC Fetch Consent Proof is mandatory only when accountType is POA or EXECUTIONARY and onboardingVia is 'physical' => START
                if (doc.documentType === 'kycFetchConsentProof') {
                  const currentAccountType = MPOWER_ACCOUNT_TYPE_MASTER[`${application?.accountType ?? ""}`?.toUpperCase()];
                  const isPOAOrExecutionary = [MPOWER_ACCOUNT_TYPE_MASTER['ADVISORY'], MPOWER_ACCOUNT_TYPE_MASTER['EXECUTIONARY']].includes(currentAccountType)

                  return {
                    ...doc,
                    required: (isPOAOrExecutionary && `${application?.onboardingVia ?? ""}`.toLowerCase() === 'physical')
                      ? 'true'
                      : 'false'
                  }
                }
                // KYC Fetch Consent Proof is mandatory only when accountType is POA or EXECUTIONARY and onboardingVia is 'physical' => END

                return doc
              })
              // to be commented out for bpi client end

              // Bank Account Proof is there only for first applicant start

              .filter((doc) => {
                if (doc.documentType === "bankAccountProof" && applicant?.applicant_type !== "1") {
                  return
                }

                return doc
              })

              // Bank Account Proof is there only for first applicant end

              // Nominee Opt Out Document Start

              // Enabling Nominee Opt Out Document based on feature flag

              .filter((doc) => {
                if (doc.documentType === "nominee_opt_out" && !NOMINEE_OPT_OUT_FEATURE_ENABLED) {
                  return
                }

                return doc
              })

              // Nominee Opt Out Document is there only for individual onboarding
              .filter((doc) => {
                if (
                  doc.documentType === "nominee_opt_out" &&
                  !(
                    isModuleAllowed({ value: (application?.onboardingType ?? ""), compareArr: [onboardingTypeMasters.normal] }) &&
                    isModuleAllowed({ value: (application?.applicationType ?? ""), compareArr: [APPLICATION_TYPE.INDIVIDUAL] })
                  )
                ) {
                  return
                }

                return doc
              })

              // Nominee Opt Out Document is there only for first applicant
              .filter((doc) => {
                if (doc.documentType === "nominee_opt_out" && applicant?.applicant_type !== "1") {
                  return
                }

                return doc
              })
              // Making Nominee Opt Out document required based on isNomineeOptOutAuthRequired condition
              .map((doc) => {
                if (doc.documentType === "nominee_opt_out" && isNomineeOptOutAuthRequired) {
                  return { ...doc, required: "true" }
                }
                return doc
              })

              // Nominee Opt Out Document End
              .map((doc: individuals_Poa_nonIndividuals_Documents, index: number) => {
                const {
                  documentType,
                  documentName,
                  multipleFiles,
                  required,
                  options,
                  uploadFormats,
                  maxFiles,
                  maxFileSize,
                  url = ""
                } = doc;
                const { documents: existingDocuments = [] } = applicant || {};
                const docsOfCurrentDocType = existingDocuments
                  .filter((doc) => doc.documentType === documentType)
                  .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId));
                return {
                  documentType: documentType,
                  documentName: documentName,
                  documentsList: docsOfCurrentDocType.length
                    ? docsOfCurrentDocType.map((doc, ind) => {
                      const {
                        id,
                        documentName = '',
                        documentType = '',
                        documentId = '',
                        isActive = true,
                        file = undefined,
                      } = doc;
                      return {
                        id,
                        applicantId: applicant?.id,
                        documentType,
                        documentName,
                        documentId,
                        isActive,
                        file,
                        options,
                        required: isHeldAway ? "false" : required,
                        uniqueKey: (applicant_index.toString() +
                          '-' +
                          index.toString() +
                          '-' +
                          ind.toString()) as string,
                      };
                    })
                    : [
                      {
                        documentType,
                        documentName,
                        required: isHeldAway ? "false" : required,
                        options,
                        uniqueKey: (applicant_index.toString() +
                          '-' +
                          index.toString() +
                          '-' +
                          '0') as string,
                        ...document_object,
                      },
                    ],
                  required: isHeldAway ? "false" : required,
                  multipleFiles,
                  options,
                  uploadFormats,
                  maxFiles,
                  maxFileSize,
                  url
                };
              })
            : [],
        onboardingType: applicant.onboardingType,
      };
    }),
    nominees: Nominees.map((nominee, nominee_index) => {
      return {
        nomineedocuments:
          typeof documentsData !== 'undefined'
            ? (isMinor(nominee.dateOfBirth || '')
              ? [
                ...((documentsData as Document)[APPLICATION_TYPE_FOR_DOCUMENTS.NOMINEE_DOC] ||
                  []),
                ...((documentsData as Document)[
                  APPLICATION_TYPE_FOR_DOCUMENTS.NOMINEE_GUARDIAN
                ] || []),
              ].map((doc) => {
                if (doc.documentType === 'nomineeIdProof') {
                  return { ...doc, required: 'false' };
                }
                return doc;
              })
              : (documentsData as Document)[APPLICATION_TYPE_FOR_DOCUMENTS.NOMINEE_DOC] || []
            ).map((doc: individuals_Poa_nonIndividuals_Documents, index: number) => {
              const {
                documentType,
                documentName,
                multipleFiles,
                required,
                options,
                uploadFormats,
                maxFiles,
                maxFileSize,
              } = doc;
              const { nomineedocuments: existingDocuments = [] } = nominee || {};
              const docsOfCurrentDocType = existingDocuments
                .filter((doc) => doc.documentType === documentType)
                .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId));
              return {
                documentType: documentType,
                documentName: documentName,
                documentsList: docsOfCurrentDocType.length
                  ? docsOfCurrentDocType.map((doc, ind) => {
                    const {
                      id,
                      documentName = '',
                      documentType = '',
                      documentId = '',
                      isActive = true,
                      file = undefined,
                    } = doc;
                    return {
                      id,
                      nomineeId: nominee?.id,
                      documentType,
                      documentName,
                      documentId,
                      isActive,
                      file,
                      options,
                      required: isHeldAway ? "false" : required,
                      uniqueKey: (nominee_index.toString() +
                        '-' +
                        index.toString() +
                        '-' +
                        ind.toString()) as string,
                    };
                  })
                  : [
                    {
                      documentType,
                      documentName,
                      required: isHeldAway ? "false" : required,
                      options,
                      uniqueKey: (nominee_index.toString() +
                        '-' +
                        index.toString() +
                        '-' +
                        '0') as string,
                      ...document_object,
                    },
                  ],
                required: isHeldAway ? "false" : required,
                multipleFiles,
                options,
                uploadFormats,
                maxFiles,
                maxFileSize,
              };
            })
            : [],
      };
    }),
  };
  try {
    await validateYupSchema(schemaData, documentDetailsSchema, true, schemaData);
  } catch (error) {
    throw `Document details`;
  }
};

export const isFormValidForSubmission = async (
  application: ApplicationProps | null,
  validateDoc = true,
  verifyPennydrop = true,
  nationalitiesMdmsMasters = {},
  documentsResponse = {},
  role = '',
  riskProfileDataMaster: RiskProfileMasterType[],
  currencyCode = "INR",
  company = "WMS"
) => {
  const {
    applicants = [],
    nominees = [],
    doNotWishToNominate = false,
    banks = [],
    hasPOA = true,
    applicationType = '',
    onboardingType = '',
  } = application || {};

  try {
    await validatePersonalDetails(applicants, role, currencyCode, company, application);
    await validateRelatedPersonDetail(applicants, role, currencyCode, company);
    await validateKYCDetails(applicants, role);
    await validateNomineeDetails(nominees, doNotWishToNominate, applicants, onboardingType, currencyCode, company);
    await validateFATCA(applicants, role, nationalitiesMdmsMasters as nationaliyType);
    // await validateBankDetails(banks, verifyPennydrop, applicationType, applicants, currencyCode);
    await validateRiskProfile(application, riskProfileDataMaster);
    (
      validateDoc &&
      Object.keys(documentsResponse).length !== 0
    ) &&
      (await validateDocuments(applicants, hasPOA, documentsResponse as Document, nominees, application));
  } catch (error) {
    if (error instanceof BankError) {
      throw (error as BankError).message;
    }
    if (error instanceof RelatedPersonError) {
      throw (error as RelatedPersonError).message;
    }
    if (error instanceof RiskProfileErrors) {
      throw (error as RiskProfileErrors).message;
    }
    throw `In ${error}, the required fields are not filled.`;
  }
};

export const pennyDropVerification =
  (body: Bank) =>
    async (dispatch: any): Promise<Bank> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/pennydropverification`,
          method: 'POST',
          types: [PENNY_DROP_VERIFICATION_SUCCESS, PENNY_DROP_VERIFICATION],
          body,
        },
      });
    };

export const getDocuments =
  () =>
    async (dispatch: any): Promise<Document> => {
      return await dispatch({
        [CALL_API]: {
          url: `${NEXEDGE_MDMS_APIS ? '/api' : ''}/mdms/required_document_master.json`,
          method: 'GET',
          types: [GET_Documents_SUCCESS, GET_Documents],
          modifyUrl: true
        },
      });
    };

export const getUboTypes =
  () =>
    async (dispatch: any): Promise<uboTypes> => {
      return await dispatch({
        [CALL_API]: {
          url: `${NEXEDGE_MDMS_APIS ? '/api' : ''}/mdms/uboTypeMaster.json`,
          method: 'GET',
          types: [GET_Ubo_SUCCESS, GET_Ubo],
          modifyUrl: true
        },
      });
    };

export const FetchData =
  (body: FetchUBORequestBody) =>
    async (dispatch: any): Promise<ubo> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/kradetails`,
          method: 'POST',
          types: [UBO_LISTING_SUCCESS, UBO_LISTING],
          body,
        },
      });
    };

export const FatcaMdmsData =
  () =>
    async (dispatch: any): Promise<FatcaMdms> => {
      return await dispatch({
        [CALL_API]: {
          url: `${NEXEDGE_MDMS_APIS ? '/api' : ''}/mdms/fatca_data.json`,
          method: 'GET',
          types: [GET_Fatca_SUCCESS, GET_Fatca],
          modifyUrl: true
        },
      });
    };

export const validateNonIndividualContributorDetails = async (applicants: Partial<Applicant>[], locale: string, application: ApplicationProps | null,) => {
  const schemaData = {
    applicants: applicants,
    familyName: application?.familyName ?? "",
    familyId: application?.familyId ?? "",
    // For first time creation familyMappingType = existing as familyId and familyName are not there
    // For edit =>
    // 1. if new selected during creation => familyId will not be there, familyName will be there, so new
    // 2. if existing selected during creation => familyId will be there, so existing
    familyMappingType: (application?.familyId ?? "") ?
      FAMILY_MAPPING_TYPE.EXISTING :
      ((application?.familyName ?? "") ?
        FAMILY_MAPPING_TYPE.NEW :
        FAMILY_MAPPING_TYPE.EXISTING),
  };
  try {
    await validateYupSchema(schemaData, NonIndividualContributorValidationSchema(locale), true, schemaData);
  } catch (error) {
    throw `Contributor details`;
  }
};
export const validateNonIndividualContactDetails = async (
  applicants: Partial<Applicant>[],
  countryDropdown: string[],
  currencyCode = "INR"
) => {
  const schemaData = {
    applicants: applicants.map((applicant) => {
      const correspondence = getAddressData('correspondence', applicant.addresses);
      const permanent = getAddressData('permanent', applicant.addresses);
      const defaultPayload = {
        contactperson: applicant.contactperson
          ? {
            ...applicant.contactperson,
            countryNameAndCode: applicant.contactperson.countryNameAndCode
              ? applicant.contactperson.countryNameAndCode
              : 'India: +91',
            country: applicant.contactperson.country
              ? applicant.contactperson.country.toUpperCase()
              : 'INDIA',
          }
          : contactPersonObject,
        address: {
          correspondence,
        },
      };
      const permanentAddressPayload = correspondence.permanentAddressSameAsCorresponding
        ? defaultPayload
        : {
          ...defaultPayload,
          address: {
            ...defaultPayload.address,
            permanent: {
              ...permanent,
              country: permanent.country ? permanent.country.toUpperCase() : 'INDIA',
            },
            correspondence: {
              ...correspondence,
              country: correspondence.country ? correspondence.country.toUpperCase() : 'INDIA',
            },
          },
        };
      return permanentAddressPayload;
    }),
    countryDropdown: countryDropdown,
  };
  try {
    await validateYupSchema(schemaData, nonIndividualContactDetailsSchema(currencyCode), true, schemaData);
  } catch (error) {
    throw `Contact details`;
  }
};

export const validateNonIndividualDocumentDetails = async (
  applicants: Partial<Applicant>[],
  documentsData: individuals_Poa_nonIndividuals_Documents[],
  banks: Partial<Bank>[],
  application: ApplicationProps | null
) => {
  const isHeldAway = MPOWER_ACCOUNT_TYPE_MASTER[`${application?.accountType ?? ""}`?.toUpperCase()] === MPOWER_ACCOUNT_TYPE_MASTER['HLDAWY'];

  const schemaData = {
    applicants: applicants.map((applicant, applicant_index) => {
      return {
        documents: documentsData
          .filter((document) => {
            if (applicant.amlCheck && document.documentType === 'compliance_document') {
              return;
            }
            return document;
          })
          .filter((ele) => ele)
          .map((doc) => {
            if (doc.documentType === 'physical_signed_document') {
              return {
                ...doc,
                required: isHeldAway ?
                  "false" :

                  // Physical Signed Doc is required when isEsignEnabled is false and it is first applicant => start

                  (
                    !(application?.isEsignEnabled) &&
                    (applicant?.applicant_type === '1')
                  ) ?
                    'true' :
                    'false'

                // Physical Signed Doc is required when isEsignEnabled is false and it is first applicant => end
              }
            }

            // KYC Fetch Consent Proof is mandatory only when accountType is POA or EXECUTIONARY and onboardingVia is 'physical' => START
            if (doc.documentType === 'kycFetchConsentProof') {
              const currentAccountType = MPOWER_ACCOUNT_TYPE_MASTER[`${application?.accountType ?? ""}`?.toUpperCase()];
              const isPOAOrExecutionary = [MPOWER_ACCOUNT_TYPE_MASTER['ADVISORY'], MPOWER_ACCOUNT_TYPE_MASTER['EXECUTIONARY']].includes(currentAccountType)

              return {
                ...doc,
                required: (isPOAOrExecutionary && `${application?.onboardingVia ?? ""}`.toLowerCase() === 'physical')
                  ? 'true'
                  : 'false'
              }
            }
            // KYC Fetch Consent Proof is mandatory only when accountType is POA or EXECUTIONARY and onboardingVia is 'physical' => END

            // When onboardingVia is 'digital', Aadhaar Card should be non-mandatory => START
            if (doc.documentType === 'aadhaar_card') {
              return {
                ...doc,
                required: (`${application?.onboardingVia ?? ""}`?.toLowerCase() === 'digital') ? "false" : doc.required
              }
            }
            // When onboardingVia is 'digital', Aadhaar Card should be non-mandatory => END

            return doc
          })
          //.map((doc) => ({ ...doc, required: 'true' }))
          .map((doc, index) => {
            const { documentType, documentName, multipleFiles, required, options } = doc;
            const { documents: existingDocuments = [] } = applicant || {};
            const docsOfCurrentDocType = existingDocuments
              .filter((doc) => doc.documentType === documentType)
              .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId));

            const isComplianceDocument = documentType === 'compliance_document'

            return {
              documentType: documentType,
              documentName: documentName,
              documentsList: docsOfCurrentDocType.length
                ? docsOfCurrentDocType.map((doc, ind) => {
                  const {
                    documentName = '',
                    documentType = '',
                    documentId = '',
                    isActive = true,
                    file = undefined,
                  } = doc;
                  return {
                    documentType,
                    documentName,
                    documentId,
                    isActive,
                    file,
                    options,
                    required: (isHeldAway && !isComplianceDocument) ? "false" : required,
                    uniqueKey: (applicant_index.toString() +
                      '-' +
                      index.toString() +
                      '-' +
                      ind.toString()) as string,
                  };
                })
                : [
                  {
                    documentType,
                    documentName,
                    required: (isHeldAway && !isComplianceDocument) ? "false" : required,
                    options,
                    uniqueKey: (applicant_index.toString() +
                      '-' +
                      index.toString() +
                      '-' +
                      '0') as string,
                    ...document_object,
                  },
                ],
              required: (isHeldAway && !isComplianceDocument) ? "false" : required,
              multipleFiles,
              options,
            };
          }),
      };
    }),
    banks: banks,
  };
  try {
    await validateYupSchema(schemaData, nonIndividualDocumentDetailsSchema({ isHeldAway }), true, schemaData);
  } catch (error) {
    throw `Document details`;
  }
};
const fieldsTocheckForAuthorisedSignatories = [
  {
    key: 'name',
    label: 'Name',
    validateMulitple: false,
  },
  {
    key: 'pan',
    label: 'PAN',
    validateMulitple: true,
    regex: individualPanRegex,
    regexMsg: 'Only Individual PANs are allowed',
  },
  { key: 'mobile', label: 'Mobile Number', validateMulitple: true },
  {
    key: 'email',
    label: 'Email ID',
    validateMulitple: true,
    regex: emailRegex,
  },
  {
    key: 'designation',
    label: 'Designation',
    validateMulitple: false,
  },
];

export const validateNonIndividualAuthorisedSignatories = async (groups: Groups[]) => {
  try {
    groups.map((group) => {
      const getActiveSignatories = group.groupsignatories.filter((item) => item.isActive);
      const getCanEsignCount = getActiveSignatories.filter((item) => item.canEsign);
      if (!getActiveSignatories.length) {
        throw new AuthorisedErrors('Please add Authorised Signatories');
      }
      if (!getCanEsignCount.length) {
        throw new AuthorisedErrors('Please Select a member for E-Sign in Authorised Signatories');
      }
      if (getCanEsignCount.length < group.threshold) {
        throw new AuthorisedErrors(
          'Authorised Signatories that can esign can not be less than the Total No. of required Authorised Signatories'
        );
      }
      getActiveSignatories.forEach((signatory, index) => {
        fieldsTocheckForAuthorisedSignatories.forEach((field) => {
          if (!signatory[field.key as keyof GroupSignatories] as unknown as string) {
            throw new AuthorisedErrors(`${field.label} is required for signatory ${index + 1}`);
          }
          if (
            field.regex &&
            !field.regex.test(signatory[field.key as keyof GroupSignatories] as unknown as string)
          ) {
            throw new AuthorisedErrors(
              field.regexMsg
                ? `${field.regexMsg} for signatory ${index + 1}`
                : `Please enter valid ${field.label} for signatory ${index + 1}`
            );
          }
          if (field.validateMulitple) {
            const values = getActiveSignatories.filter(
              (vsignatory) =>
                (vsignatory[field.key as keyof GroupSignatories] as unknown as string) ===
                (signatory[field.key as keyof GroupSignatories] as unknown as string)
            );
            if (values.length > 1) {
              throw new AuthorisedErrors(
                `There is already same ${field.label} for an Authorised Signatory associated with this application`
              );
            }
          }
        });
      });
      return group;
    });
  } catch (error) {
    if (error instanceof AuthorisedErrors) {
      throw error;
    }
  }
};

const fieldsTocheckForUbos = [
  {
    key: 'panNumber',
    label: 'Taxpayer ID Number/PAN/Equivalent ID Number',
    validateMulitple: true,
    required: true,
  },
  {
    key: 'dob',
    label: 'Date of Birth',
    validateMulitple: false,
    required: true,
  },
  { key: 'name', label: 'Name of UBO', validateMulitple: false, required: true },
  {
    key: 'identificationType',
    label: 'Identification Type',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'percentageOfBeneficialInterest',
    label: 'Percentage of beneficial interest',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'countryOfTaxResidency',
    label: 'Country of Tax Residency',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'cpUboCode',
    label: 'CP/UBO Code',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'placeAndCountryOfBirth',
    label: 'Place & Country of Birth',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'occupation',
    label: 'Occupation',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'gender',
    label: 'Gender',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'nationality',
    label: 'Nationality',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'fatherName',
    label: 'Father Name',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'ckycNumber',
    label: 'CKYC Number',
    validateMulitple: true,
    required: false,
  },
  {
    key: 'address2',
    label: 'Address 1',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'address3',
    label: 'Address 2',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'pincode',
    label: 'Pincode',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'city',
    label: 'City',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'state',
    label: 'State',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'country',
    label: 'Country',
    validateMulitple: false,
    required: true,
  },
];
const validateNonIndividualUbo = async (
  applicants: Partial<Applicant>[],
  ubo_declaration_type: string,
  ubo_declaration_value: string,
  ubos: ubo[],
  nationalityDropdown: string[],
  countryDropdown: string[]
) => {
  try {
    const applicantsCkycNumbers = applicants?.map((applicant) => applicant.ckycNo);
    if (!ubo_declaration_type) {
      throw new UboErrors('Please Select Declaration Type in Declaration of Ubo');
    }
    if (!ubo_declaration_value) {
      throw new UboErrors('Please Select Declaration value in Declaration of Ubo');
    }
    if (ubo_declaration_type === 'none' && !ubos.filter((_item) => _item.isActive).length) {
      throw new UboErrors('Please Add Ultimate Benificiary Owners(UBO)');
    }
    if (ubos.filter((_item) => _item.isActive).length) {
      const activeUbos = ubos.filter((_item) => _item.isActive);
      activeUbos.map((ubo) => {

        const isNonIndividualPan = (
          `${ubo?.identificationType ?? ""}`.toLowerCase() === 'pan card' &&
          !individualPanRegex.test(ubo?.panNumber ?? "") &&
          nonIndividualPanRegex.test(ubo?.panNumber ?? "")
        )

        if (ubo.ckycNumber && applicantsCkycNumbers.includes(ubo.ckycNumber)) {
          throw new UboErrors(
            `CKYC Number of ${ubo.name} should not be same as CKYC Number exist in Contributor Details`
          );
        }
        if (!nationalityDropdown.includes(ubo.nationality || '')) {
          throw new UboErrors(`Invalid Nationality for ${ubo.name} in Declaration of Ubo`);
        }
        if (!countryDropdown.includes(ubo.country || '')) {
          throw new UboErrors(`Invalid Country for ${ubo.name} in Declaration of Ubo`);
        }
        if (!countryDropdown.includes(ubo.countryOfTaxResidency || '')) {
          throw new UboErrors(
            `Invalid Country of Tax Residency for ${ubo.name} in Declaration of Ubo`
          );
        }
        // if (!occupationDetailsMasters.includes(ubo.occupation || '')) {
        //   throw new UboErrors(`Invalid Occupation for ${ubo.name} in Declaration of Ubo`);
        // }
        if (!isNonIndividualPan && !uboOccupationDetailsMasters.includes(ubo.occupation || '')) {
          throw new UboErrors(`Invalid Occupation for ${ubo.name} in Declaration of Ubo`);
        }
      });
      percentageError(ubos, true);
    }
    ubos
      .filter((_item) => _item.isActive)
      .forEach((ubo, index) => {

        const isNonIndividualPan = (
          `${ubo?.identificationType ?? ""}`.toLowerCase() === 'pan card' &&
          !individualPanRegex.test(ubo?.panNumber ?? "") &&
          nonIndividualPanRegex.test(ubo?.panNumber ?? "")
        )

        fieldsTocheckForUbos.forEach((field) => {
          if ((
            !ubo[field.key as keyof ubo] as unknown as string) &&
            field.required &&
            !(isNonIndividualPan && ['occupation', 'gender', 'fatherName'].includes(field?.key ?? ""))
          ) {
            throw new UboErrors(`${field.label} is required for ubo ${index + 1}`);
          }
          if (
            field.key === 'dob' &&
            (ubo[field.key as keyof ubo] as unknown as string) &&
            isMinor(field.key)
          ) {
            throw new UboErrors(`Age should be greater than 18 for ubo ${index + 1}`);
          }
          if (
            field.key === 'percentageOfBeneficialInterest' &&
            (ubo[field.key as keyof ubo] as unknown as number) <= 0
          ) {
            throw new UboErrors(
              `Percentage Of Beneficial Interest should be greater 0 for ubo ${index + 1}`
            );
          }
          if (
            field.key === 'percentageOfBeneficialInterest' &&
            (ubo[field.key as keyof ubo] as unknown as number) > 100
          ) {
            throw new UboErrors(
              `Percentage Of Beneficial Interest must not exceed 100% for ubo ${index + 1}`
            );
          }
          if (field.validateMulitple) {
            const values = ubos.filter(
              (_ubo) =>
                (_ubo[field.key as keyof ubo] as unknown as string) ===
                (ubo[field.key as keyof ubo] as unknown as string) &&
                (ubo[field.key as keyof ubo] as unknown as string) &&
                (_ubo[field.key as keyof ubo] as unknown as string)
            );
            if (values.length > 1) {
              throw new UboErrors(
                `There is already same ${field.label} for an Ubos associated with this application`
              );
            }
          }
        });
      });
  } catch (e) {
    if (e instanceof UboErrors) {
      throw e;
    }
  }
};
export const nonIndividualFormValidForSubmission = async (
  application: ApplicationProps | null,
  documentsData: individuals_Poa_nonIndividuals_Documents[],
  mdmsCountriesList: mdmsCountriesList[],
  verifyPennydrop = true,
  currencyCode = "INR",
  locale = "en-IN",
  validateDoc = true
) => {
  const {
    applicants = [],
    banks = [],
    groups = [],
    ubo_declaration_type = '',
    ubo_declaration_value = '',
    ubos = [],
    applicationType = '',
  } = application || {};
  const nationalityDropdown = mdmsCountriesList.map((list) => list.nationality);
  const countryDropdown = mdmsCountriesList.map((list) => list.name);
  try {
    await validateNonIndividualContributorDetails(applicants, locale, application);
    await validateNonIndividualContactDetails(applicants, countryDropdown, currencyCode);
    // await validateBankDetails(banks, verifyPennydrop, applicationType, applicants, currencyCode);
    await validateNonIndividualAuthorisedSignatories(groups);
    await validateNonIndividualUbo(
      applicants,
      ubo_declaration_type,
      ubo_declaration_value,
      ubos,
      nationalityDropdown,
      countryDropdown
    );
    if (validateDoc) {
      await validateNonIndividualDocumentDetails(applicants, documentsData, banks, application);
    }
  } catch (error) {
    if (error instanceof UboErrors) {
      throw (error as UboErrors).message;
    }
    if (error instanceof AuthorisedErrors) {
      throw (error as AuthorisedErrors).message;
    }
    if (error instanceof BankError) {
      throw (error as BankError).message;
    }
    throw `In ${error}, the required fields are not filled.`;
  }
};

export const resubmitFatca =
  (body: ResubmitFatcaRequestBody) =>
    async (dispatch: any): Promise<Array<ResubmitFatcaResponseBody>> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/onboarding/resubmit-fatca`,
          method: 'POST',
          types: [RESUBMIT_FATCA_SUCCESS, RESUBMIT_FATCA],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const updateChequeStatus =
  (body: UpdateChequeStatusRequestBody) =>
    async (dispatch: any): Promise<UpdateChequeStatusResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/onboarding/update-cheque-status`,
          method: 'POST',
          types: [UPDATE_CHEQUE_STATUS_SUCCESS, UPDATE_CHEQUE_STATUS],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const nomineeOptOutGenerateOtp =
  (body: NomineeOptOutGenerateOtpRequestBody) =>
    async (dispatch: any): Promise<ApplicationProps> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/nominee-opt-out/send-otp`,
          method: 'POST',
          types: [NOMINEE_OPT_OUT_GENERATE_OTP_SUCCESS, NOMINEE_OPT_OUT_GENERATE_OTP],
          // body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          body
        },
      });
    };

export const nomineeOptOutVerifyOtp =
  (body: NomineeOptOutVerifyOtpRequestBody) =>
    async (dispatch: any): Promise<NomineeOptOutVerifyOtpResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/nominee-opt-out/verify-otp`,
          method: 'POST',
          types: [NOMINEE_OPT_OUT_VERIFY_OTP_SUCCESS, NOMINEE_OPT_OUT_VERIFY_OTP],
          // body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          body
        },
      });
    };

export const nomineeOptOutResendOtp =
  (body: NomineeOptOutResendOtpRequestBody) =>
    async (dispatch: any): Promise<ApplicationProps> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/nominee-opt-out/resend-otp`,
          method: 'POST',
          // NOMINEE_OPT_OUT_RESEND_OTP_SUCCESS is used to store the response in application store
          types: [NOMINEE_OPT_OUT_RESEND_OTP_SUCCESS, NOMINEE_OPT_OUT_RESEND_OTP],
          // body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          body
        },
      });
    };

export const nomineeOptOutApplicationPreview =
  (token: string) =>
    async (dispatch: any): Promise<NomineeOptOutApplicationPreviewResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/nominee-opt-out/application-preview/${token}`,
          method: 'GET',
          types: [NOMINEE_OPT_OUT_APPLICATION_PREVIEW_SUCCESS, NOMINEE_OPT_OUT_APPLICATION_PREVIEW]
        },
      });
    };

export const getBankSubAccountTypes =
  (body: GetBankSubAccountTypesRequestBody) =>
    async (dispatch: any): Promise<GetBankSubAccountTypesResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/applications/bankSubAccountTypes',
          method: 'POST',
          types: [GET_BANK_SUB_ACCOUNT_TYPES_SUCCESS, GET_BANK_SUB_ACCOUNT_TYPES],
          body
        },
      });
    };
